module.exports = __webpack_public_path__ + "img/buis.bbce0cb1.jpg";